import React from 'react';

function GuestValidationChecklist() {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#1A1A1A',
      color: '#FFFFFF',
      fontFamily: 'Arial, sans-serif',
      padding: '20px',
      textAlign: 'center'
    }}>
      {/* Logo en la parte superior */}
      <img 
        src="https://cdn.hidalgo.gob.mx/gobierno/images/logos/logo_gob.png" // Cambia esta URL al enlace de tu logo
        alt="Logo"
        style={{
          width: '120px',
          marginBottom: '40px',
          borderRadius: '8px'
        }}
      />

      {/* Mensaje de bienvenida estilizado */}
      <div style={{
        backgroundColor: '#2E2E2E',
        padding: '30px',
        borderRadius: '10px',
        boxShadow: '0 4px 10px rgba(0, 0, 0, 0.3)',
        maxWidth: '400px',
        width: '100%'
      }}>
        <h2 style={{
          fontSize: '24px',
          fontWeight: 'bold',
          marginBottom: '10px',
          color: '#4CAF50'
        }}>Invitado Verificado</h2>
        <p style={{
          fontSize: '18px',
          margin: '0'
        }}>Bienvenido al evento</p>
      </div>

      {/* Aviso de privacidad de datos */}
      <p style={{
        fontSize: '12px',
        color: '#B0B0B0',
        marginTop: '40px',
        maxWidth: '400px',
        lineHeight: '1.5'
      }}>
        Al ingresar, aceptas los términos y condiciones de privacidad de datos. La información proporcionada será utilizada exclusivamente para fines de verificación de acceso al evento y no será compartida con terceros.
      </p>
    </div>
  );
}

export default GuestValidationChecklist;
